import { useQuery, QueryFunction } from 'react-query';
import { Dump, getAllDumps, GetDumpsQueries } from '../../services/apiSLTP/materials/dumps';

type UseDumpsQueryOptions = {
    queries?: GetDumpsQueries;
};

const getDumps: QueryFunction<Dump[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseDumpsQueryOptions];
    const { queries } = options;

    const response = await getAllDumps(queries);
    return response.data;
};

export const useDumpsQuery = (options: UseDumpsQueryOptions) => {
    return useQuery(['dumps', options], getDumps);
};
